import { render, staticRenderFns } from "./ownLogisticsChannelsModal.vue?vue&type=template&id=b8181a96&scoped=true"
import script from "./ownLogisticsChannelsModal.vue?vue&type=script&lang=js"
export * from "./ownLogisticsChannelsModal.vue?vue&type=script&lang=js"
import style0 from "./ownLogisticsChannelsModal.vue?vue&type=style&index=0&id=b8181a96&prod&lang=less"
import style1 from "./ownLogisticsChannelsModal.vue?vue&type=style&index=1&id=b8181a96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8181a96",
  null
  
)

export default component.exports